export enum EUserSuspendStatus {
  PENDING = "pending",
  ACTIVE = "active",
  IN_ACTIVE = "inactive",
}

export enum EUserSuspendMode {
  SCHEDULE = "schedule",
  IMMEDIATE = "immediate",
}

export interface IUserSuspendUpdate {
  mode: EUserSuspendMode;
  reason?: string;
  date?: string;
}

export interface ICreateUserSuspend {
  userId: string;
  reason?: string;
  date?: string;
  status?: EUserSuspendStatus;
  mode?: EUserSuspendMode;
}

export type IUserSuspend = {
  id: string;
  userId: string;
  userConfigId: string;
  reason: string;
  date: string;
  status: EUserSuspendStatus;
  mode: EUserSuspendMode;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
} & Record<string, unknown>;